import { AfterViewInit, Component } from '@angular/core';
import { AnalyticEvent, AnalyticsBloc } from '@kanalytics';
import { environment } from '@kp/../environments/environment';
import { AuthenticationBloc } from '@kp/auth/authentication.bloc';
import { DataLinkBloc } from '@kp/data-link/data-link.bloc';
import { Constants } from '@kp/shared/constants.service';
import { Popup } from '@kutil';

@Component({
  selector: 'kp-screen-logout',
  templateUrl: './screen-logout.component.html',
  styleUrls: ['./screen-logout.component.scss'],
})
export class ScreenLogoutComponent implements AfterViewInit {
  popup: Popup;
  logoutCalled = false;

  constructor(
    private _analyticsBloc: AnalyticsBloc,
    public authenticationBloc: AuthenticationBloc,
    private _dataLinkBloc: DataLinkBloc,
    private _popupService: Popup
  ) {}

  ngAfterViewInit() {
    // shouldn't have linkData at this point, but just in case, clear it out
    this._dataLinkBloc.clearLinkData();
    this.popup = this._popupService.initialize({
      url: 'about:blank',
      name: 'ssologout',
      windowFeatures: {
        width: 100,
        height: 100,
      },
      onClose: this.onPopupClose.bind(this),
    });

    setTimeout(() => {
      this._analyticsBloc.sendEvent(this._analyticsBloc.createEventFromEvent({ event: AnalyticEvent.app_exit }));

      // Make sure the user is logged out
      if (this.popup) {
        this.popup.resizeTo(1, 1);
        const url = Constants.ssoLogoutUrlTemplate
          .replace('$authHost', environment.oauth.domain)
          .replace('$clientId', environment.oauth.authClientSocialId)
          .replace('$kumanuLogout', encodeURIComponent(environment.oauth.redirectSignOut));

        // Make sure the user is logged out
        this.popup.change_url(url);

        // check for url change and close popup
        this.checkPopupUrl();

        // force logout after 4 seconds regardless
        setTimeout(() => {
          if (this.popup) {
            this.popup.close();
          }
          if (!this.logoutCalled) {
            this.authenticationBloc.logout();
            this.logoutCalled = true;
          }
        }, 4000);
      }
    });
  }

  private checkPopupUrl() {
    if ((this.popup?.popupWin?.location?.href || '').includes(environment.oauth.redirectSignOut)) {
      this.popup.close();
      if (!this.logoutCalled) {
        this.authenticationBloc.logout();
        this.logoutCalled = true;
      }
      return;
    }

    // check for url change and close popup
    setTimeout(() => {
      this.checkPopupUrl();
    }, 250);
  }

  private onPopupClose() {
    if (this && !this.logoutCalled) {
      this.authenticationBloc?.logout();
      this.logoutCalled = true;
    }
  }
}
